import Vue from 'vue';
if(document.getElementById('partner')) {
    var partner = new Vue({
        el:'#partner',
        data:{
            archive:{},
            schedule:{},
            partner: {},
            load: false,
            page: 1,
            pageCount: 0
        },
        mounted:function () {
          this.fetchPartner();
            this.fetchSchedule();
            this.fetchArchive();

        },
        methods:{
            fetchPartner: function () {
                var self = this;

                this.load = true;

                try {
                    $.ajax({
                        url: '/api/v1/partner/view',
                        dataType: "json",
                        data: {id:partnerId},
                        success: function (data) {
                            console.log(data.item);
                            self.partner = data.item;
                        },
                        fail: function () {
                            throw new Error('Ошибка получении данных');
                        }
                    });
                    console.log(partner);

                } catch (e) {
                    console.error(e);
                }
            },
            classRating: function (rating) {

                return {
                    'best': (rating > 4 ),
                    'good': (rating > 3 && rating <= 4),
                    'normal': (rating > 2 && rating <= 3),
                    'poorly': (rating > 1 && rating <= 2),
                    'bad': rating <= 1
                };
            },
            fetchSchedule:function(){
                var self = this;

                $.ajax({
                    url: '/api/v1/lection',
                    dataType: "json",
                    data: {'schedule':1,sponsor_id:partnerId},
                    success: function (data) {

                        self.schedule = data;
                    },
                    fail: function () {

                        throw new Error('Ошибка получении данных');

                    }
                });
            },
            fetchArchive:function(append){
                var self = this;
                this.load = true;

                try {

                    var data = {'schedule':0,sponsor_id:partnerId};

                    $.extend(data, {page: this.page});

                    $.ajax({
                        url: '/api/v1/lection',
                        dataType: "json",
                        data: data,
                        success: function (data) {
                            if (append === true) {
                                $.each(data.items, function (i, item) {

                                    self.archive.items.push(item);

                                });

                            } else {

                                self.archive = data;
                                self.pageCount = data._meta.pageCount;
                                self.page = 1;

                            }
                            self.load = false;

                        },
                        fail: function () {

                            throw new Error('Ошибка получении данных');

                        }
                    });

                } catch (e) {

                    console.error(e);

                }
            },
        }
    });
}